package pl.mothdigital.neuronowi.pages.therapies.terapiaReki

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyHandPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Terapia ręki",
            icon = { FaHandsHolding() },
            description = "Rozwijanie sprawności manualnej, koordynacji wzrokowo-ruchowej oraz precyzji ruchów dłoni i palców.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest terapia ręki?",
                    content = """
                        Terapia ręki to specjalistyczna forma rehabilitacji skupiająca się na poprawie funkcjonowania
                        kończyn górnych, ze szczególnym uwzględnieniem dłoni i palców. W przypadku dzieci, terapia ręki
                        koncentruje się na rozwijaniu motoryki małej, koordynacji wzrokowo-ruchowej oraz przygotowaniu
                        do umiejętności szkolnych takich jak pisanie czy rysowanie.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia ręki?",
                    content = """
                        Terapia ręki jest szczególnie pomocna dla dzieci z:

                        • Opóźnieniami w rozwoju motoryki małej
                        • Trudnościami w nauce pisania
                        • Problemami z koordynacją wzrokowo-ruchową
                        • Zaburzeniami napięcia mięśniowego ręki
                        • Nieprawidłowym chwytaniem przedmiotów
                        • Trudnościami w wykonywaniu czynności samoobsługowych
                        • Zaburzeniami ze spektrum autyzmu
                        • Dysgrafią (zaburzenia pisma)
                        • Skutkami urazów kończyny górnej
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi terapia ręki?",
                    content = """
                        Prawidłowo prowadzona terapia ręki może przynieść wiele korzyści:

                        • Poprawę siły i wytrzymałości mięśni ręki
                        • Zwiększenie zakresu ruchu w stawach
                        • Lepszą koordynację wzrokowo-ruchową
                        • Poprawę precyzji ruchów palców
                        • Lepsze panowanie nad narzędziami do pisania
                        • Zwiększenie sprawności w czynnościach codziennych
                        • Poprawę planowania ruchowego
                        • Wzrost pewności siebie w działaniach manualnych
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii ręki w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową ocenę funkcji ręki - badanie siły, zakresu ruchu, koordynacji,
                           czucia oraz sprawności funkcjonalnej.

                        2. Opracowanie indywidualnego programu terapeutycznego dostosowanego do potrzeb
                           i możliwości dziecka.

                        3. Regularne sesje terapeutyczne z wykorzystaniem specjalistycznych ćwiczeń,
                           zabaw i materiałów terapeutycznych.

                        4. Trening umiejętności praktycznych - nauka prawidłowego trzymania kredki,
                           pisania, posługiwania się nożyczkami.

                        5. Edukację rodziców dotyczącą kontynuowania ćwiczeń w domu oraz adaptacji
                           środowiska domowego.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii ręki stosujemy różnorodne techniki i podejścia:

                        • Ćwiczenia wzmacniające mięśnie ręki i przedramienia
                        • Aktywności rozwijające koordynację wzrokowo-ruchową
                        • Trening sprawności manualnej z wykorzystaniem różnych materiałów
                        • Ćwiczenia proprioceptywne dla ręki
                        • Stymulację czuciową różnymi fakturami
                        • Trening przygotowujący do pisania (pre-writing skills)
                        • Adaptację narzędzi i pomocy dla ułatwienia funkcjonowania
                        • Elementy terapii zajęciowej dostosowane do wieku
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię ręki w naszym centrum prowadzą doświadczeni terapeuci occupational therapy
                        oraz fizjoterapeuci z dodatkowym przygotowaniem w zakresie terapii ręki u dzieci.
                        Nasi specjaliści posiadają szeroką wiedzę z zakresu rozwoju motoryki małej i regularnie
                        podnoszą swoje kwalifikacje, aby zapewnić pacjentom dostęp do najskuteczniejszych metod terapeutycznych.
                    """.trimIndent()
                )
            )
        )
    )
}
